import React, { PureComponent } from 'react';
import { IPart } from 'types';
import ImageAvatar from 'ui/image/image-avatar';
import { ICON_DELETE, ICON_EDIT, ICON_CLOSE, ICON_COPY } from 'icons';
import Button from 'ui/button';
// Components

interface PartItemProps {
  part: IPart;
  onRemove?: (part: IPart) => void;
  onEdit?: (part: IPart) => void;
  onClone?: (part: IPart) => void;
}
export default class PartItem extends PureComponent<PartItemProps> {
  handleEdit = () => this.props.onEdit(this.props.part);
  handleRemove = () => this.props.onRemove(this.props.part);
  handleClone = () => this.props.onClone(this.props.part);
  handleDelete = () => this.props.onDelete(this.props.part);
  render() {
    const { part, onRemove, onEdit, onClone } = this.props;
    return (
      <div className="row list-item">
        <ImageAvatar small image={part.image} className="tiny-margin" />
        <div className="column flex">
          <h3 className="tiny-margin">{part.name}</h3>
          <div className="text-fade tiny-margin">{part.description}</div>
        </div>
        {onEdit && <Button icon={ICON_EDIT} className="tiny-margin" onClick={this.handleEdit} />}
        {onClone && <Button icon={ICON_COPY} className="tiny-margin" onClick={this.handleClone} />}
        {onRemove && (
          <Button icon={ICON_CLOSE} className="tiny-margin" onClick={this.handleRemove} />
        )}
      </div>
    );
  }
}
